import { render, staticRenderFns } from "./inserir-token.vue?vue&type=template&id=bd962576&"
import script from "./inserir-token.vue?vue&type=script&lang=js&"
export * from "./inserir-token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd962576')) {
      api.createRecord('bd962576', component.options)
    } else {
      api.reload('bd962576', component.options)
    }
    module.hot.accept("./inserir-token.vue?vue&type=template&id=bd962576&", function () {
      api.rerender('bd962576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/inserir-token.vue"
export default component.exports